import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import IPage from 'models/Page';
import { PageEditFormProps } from '../pageEditRegistry';
import BannerForm from 'pages/OwnerPage/QuizFormPage/TabContentPages/Banner/BannerForm';

const BannerPageForm: FC<PageEditFormProps> = ({ pageRef }) => {
  const { watch } = useFormContext();
  const pages: IPage[] = watch('pages') || [];
  const page = pages.find((p: IPage) => p.uuid === pageRef);
  const bannerRef = page?.refs?.[0];

  if (!bannerRef) return null;

  return <BannerForm bannerRef={bannerRef} />;
};

export default BannerPageForm;
